import { render, staticRenderFns } from "./Printers.vue?vue&type=template&id=e7c71ec4&scoped=true&"
import script from "./Printers.vue?vue&type=script&lang=js&"
export * from "./Printers.vue?vue&type=script&lang=js&"
import style0 from "./Printers.vue?vue&type=style&index=0&id=e7c71ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c71ec4",
  null
  
)

export default component.exports